import React from "react";
import { Link } from "react-router-dom";

const ContactShowcase = ({ stack }) => {
  return (
    <section className="py-3 showcase">
      <div className="container text-center">
        <h4 className="font-heading m-0 underline">Take the next step</h4>
        <p className="font-normal my-3">
          Finding the right tech talent can be difficult and time consuming,
          <br /> let's make it easier and efficient for you by helping you hire{" "}
          <span className="text-capitalise">{stack}</span> Developers
        </p>
        <div className="d-flex justify-content-center">
          <Link to="/contact" className="bg-blue text-white px-3 py-1 rounded font-normal">Contact Us</Link>
        </div>
      </div>
    </section>
  );
};

export default ContactShowcase;
